import { Input } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ImageNameFilter = ({
  initialValue,
  onChange,
}: {
  initialValue?: string
  onChange: (v: string) => void
}) => {
  const { t } = useTranslation()

  const [value, setValue] = useState(initialValue)

  return (
    <Input
      name="imageNameFilter"
      id="imageNameFilter"
      type="text"
      label={t('Image Name')}
      placeholder={t('Filter...')}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const stringValue = e.target.value
        setValue(stringValue)
        onChange(stringValue)
      }}
    />
  )
}

export default ImageNameFilter
